

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('TrackOrderCtrl', function ($scope,$rootScope) {
$rootScope.title='Track your order';


});

